<h1 mat-dialog-title class="treeslo-modal-header">
    <span class="treeslo-modal-header__title">{{ data.title }}</span>
</h1>

<mat-dialog-content>
    <p class="search-complete-dialog__message">{{ data.message }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <div class="treeslo-modal-actions">
        <button mat-flat-button color="primary" type="button" (click)="onOk()" cdkFocusInitial>
            {{ data.okAction }}
        </button>
    </div>
</mat-dialog-actions>
